import React from 'react';
export function StepsSection() {
  const steps = [{
    num: '1',
    title: 'Identifica',
    desc: 'Descargas el manual e identificas tus "Errores Fantasma" con mi checklist.'
  }, {
    num: '2',
    title: 'Envía',
    desc: 'Copias mis Plantillas de Disputa Emocional y las envías siguiendo mi calendario.'
  }, {
    num: '3',
    title: 'Celebra',
    desc: 'Observas cómo tu puntaje sube mientras las cuentas negativas desaparecen y regresas al banco por tu pre-aprobación.'
  }];
  return <section className="bg-brand-cream py-16 md:py-24 px-4" data-id="element-189">
      <div className="max-w-5xl mx-auto" data-id="element-190">
        <h2 className="font-heading text-4xl md:text-5xl font-bold text-center text-brand-navy mb-16" data-id="element-191">
          Cómo funciona:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-192">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-1 bg-brand-gold/30 z-0" data-id="element-193"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-194">
              <div className="w-24 h-24 bg-brand-navy rounded-full flex items-center justify-center border-4 border-brand-gold mb-6 shadow-lg" data-id="element-195">
                <span className="font-heading text-4xl font-bold text-brand-gold" data-id="element-196">
                  {step.num}
                </span>
              </div>
              <h3 className="font-heading text-2xl font-bold text-brand-navy mb-4" data-id="element-197">
                Paso {step.num}: {step.title}
              </h3>
              <p className="font-body text-gray-600 text-lg max-w-xs" data-id="element-198">
                {step.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}